import { render, staticRenderFns } from "./ProcessSummary.vue?vue&type=template&id=5b738f9c&scoped=true&"
import script from "./ProcessSummary.vue?vue&type=script&lang=js&"
export * from "./ProcessSummary.vue?vue&type=script&lang=js&"
import style0 from "./ProcessSummary.vue?vue&type=style&index=0&id=5b738f9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b738f9c",
  null
  
)

export default component.exports